interface SchemaOrgProps {
  data: Record<string, unknown> | Record<string, unknown>[];
}

export default function SchemaOrg({ data }: SchemaOrgProps) {
  const items = Array.isArray(data) ? data : [data];
  const json = items.map(item => {
    if (!item['@context']) {
      return { '@context': 'https://schema.org', ...item };
    }
    return item;
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
    />
  );
}